import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '@fuse/services/auth/auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileService } from '@fuse/services/profile.service';
// import { ProjectService } from '../project/project.service';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm, AbstractControl } from '@angular/forms';
import { MatSnackBar, MatDialogRef, MatDialog, ErrorStateMatcher, DateAdapter } from '@angular/material';
import { NotificationsService } from '@fuse/services/notifications/notifications.service';
import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { UploadOptions } from '@fuse/components/upload/upload.model';
import { FuseUploadService } from '@fuse/components/upload/upload.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import { MemberPassword } from '@fuse/types/password';

@Component({
    selector: 'profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;
    private _fuseConfig: FuseConfig;

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

    loggedIn = false;
    signedInAlready = false;
    showSignInButton = false;
    profileData: any;
    projectsData = [];
    profileImage: any;
    profileDemogs = [];
    rawDemogs: any;
    rawProfile: any;
    docFiles = [];
    cvFile: any;
    checkboxErrors = {};
    gdprFlag = 0;
    cities: any[];
    dialogRef: any;
    maxDate = new Date().toISOString().slice(0, 10);

    activeTabIndex = 0;

    basicProfileForm: FormGroup;
    additionalProfileForm: FormGroup;
    memberPasswordForm: FormGroup;
    memberFirstPasswordForm: FormGroup;
    uploadOptionsProfileImage: UploadOptions;

    memberPassword: MemberPassword;
    matcher: ErrorStateMatcher;
    passwordDataNoEdit = true;
    basicDataNoEdit = true;
    additionalDataNoEdit = true;

    unreadedNotifications = '';

    filterCountry = [];
    filterCity = [];
    filterEmploy = [];
    filterPosition = [];
    lang = localStorage.getItem('lang') || 'sr';
    categories = [6, 14, 15, 16, 17, 18];
    defaultFilters = {};

    skillGroups = [];
    allSkills = {};
    memberSkills = {};

    genderData = [];
    languageData = [];
    levelData = [];
    levelDataObj = {};
    customDemogDataChild = [];
    customDemogDataLang = [];
    customDemogDataExperience = [];
    customDemogDataEducation = [];

    declaredSiteIdSelected = '';
    residenceSiteIdSelected = '';

    constructor(
        private _authService: AuthService,
        private _profileService: ProfileService,
        private _notificationsService: NotificationsService,
        private _formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private _router: Router,
        private _uploadService: FuseUploadService,
        private _matSnackBar: MatSnackBar,
        public _matDialog: MatDialog,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService,
        private dateAdapter: DateAdapter<Date>
    ) {
        // Set the defaults
        this._unsubscribeAll = new Subject();
        this._fuseConfig = fuseConfig;
        this.matcher = new MyErrorStateMatcher();
        this.memberPassword = new MemberPassword({});
        this.memberPasswordForm = this.createPasswordForm();
        this.memberFirstPasswordForm = this.createFirstPasswordForm();

        this.dateAdapter.setLocale('en-gb');
    }

    private createImageFromBlob(image: Blob): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            this.profileImage = reader.result;
        }, false);

        if (image) {
            reader.readAsDataURL(image);
        }
    }

    private createPasswordForm(): FormGroup {
        return this._formBuilder.group({
            password: [this.memberPassword.password, [PasswordValidation.WeakPassword]],
            confirmPassword: [''],
            oldPassword: [this.memberPassword.oldPassword]
        }, { validator: [this.checkPasswords] });
    }

    private createFirstPasswordForm(): FormGroup {
        return this._formBuilder.group({
            password: [this.memberPassword.password, [PasswordValidation.WeakPassword]],
            confirmPassword: ['']
        }, { validator: [this.checkPasswords] });
    }

    private checkPasswords(group: FormGroup): any {
        const pass = group.get('password').value;
        const confirmPass = group.get('confirmPassword').value;
        return pass === confirmPass ? null : { notSame: true };
    }

    private createBasicProfileForm(): FormGroup {
        console.log(this.profileData.date_of_birth);
        console.log(this.dateLocale(this.profileData.date_of_birth));
        return this._formBuilder.group({
            first_name: [{ value: this.profileData.first_name, disabled: false }, [Validators.required, this.noWhitespaceValidator]],
            last_name: [{ value: this.profileData.last_name, disabled: false }, [Validators.required, this.noWhitespaceValidator]],
            // title: [this.profileData.title],
            email: [{ value: this.profileData.email, disabled: true }, [Validators.email]],
            phone_number: [{ value: this.profileData.phone_number, disabled: false }, [Validators.required, Validators.minLength(10), Validators.pattern(/^([+-]?[1-9]\d*|0)$/)]],
            date_of_birth: [{ value: this.profileData.date_of_birth || null, disabled: false }, []],
            identity_number: [this.profileData.identity_number || null],
            declared_address: [this.profileData.declared_address || null],
            residence_address: [this.profileData.residence_address || null],
            declared_city_id: [this.profileData.declared_city_id || null],
            declaredCityName: [this.profileData.declaredCityName || ''],
            residence_city_id: [this.profileData.residence_city_id || null],
            residenceCityName: [this.profileData.residenceCityName || ''],
            // address: [this.profileData.address || ''],
            parent_first_name: [this.profileData.parent_first_name || ''],
            phone_number_fix: [this.profileData.phone_number_fix || ''],
            email2: [{ value: this.profileData.email2, disabled: false }, [Validators.email]],
            doctor: [this.profileData.doctor || ''],
            bank_account_number: [this.profileData.bank_account_number || '']
        });
    }

    public noWhitespaceValidator(control: FormControl): any {
        const value = (control.value || '').toString();
        const isWhitespace = (value.trim()).length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { whitespace: true };
    }

    private createAdditionalProfileForm(): FormGroup {
        return this._formBuilder.group({});
    }

    private setupUploaderOptions(): void {

        this.uploadOptionsProfileImage = {
            url: this._fuseConfig.api.url + '/portal/asset/add',
            multiple: false,
            accept: 'image/jpeg, image/png',
            maxFileSize: 3145728,
            collection: 'profile',
            iconButton: true,
            buttonTitle: this._translate.instant('Upload')
        };

    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getMultipleTranslationCategories(this.lang, this.categories);
                this.dateAdapter.setLocale(this.lang);
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    private addDefaultValueToFilters(): void {
        // Default filter name translations can be done here

        this.filterCountry = { ...this.defaultFilters['country'], ...{ 0: this._translate.instant('all') } };
        this.filterCity = { ...this.defaultFilters['city'], ...{ 0: this._translate.instant('all') } };
        this.filterEmploy = { ...this.defaultFilters['employ'], ...{ 0: this._translate.instant('all') } };
        this.filterPosition = { ...this.defaultFilters['position'], ...{ 0: this._translate.instant('all') } };
    }

    private updateDataDateFormat(data): void {
        console.log(data);

        data.forEach(element => {
            const d = new Date(element.updated || element.updated_at);
            const datestring = moment(d);
            element.updated = datestring.locale(this.lang).format('L');
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // convenience getter for easy access to form fields
    get f(): any { return this.basicProfileForm.controls; }

    dateLocale(date): any {
        const datestring = moment(date);
        return datestring.locale(this.lang).format('L');
    }

    getMemberProfile(): void {
        this._profileService.getProfile()
            .then(response => {
                if (response.data) {
                    this.profileData = response.data;
                    this.getMemberProfileImage();
                }
            });
    }

    getMemberProfileImage(): void {
        this._profileService.getMemberProfileImage()
            .then(response => {
                this.createImageFromBlob(response);
            });
    }

    getMemberProjects(): void {
        this._profileService.listUserProjects()
            .then(response => {
                if (response.data) {
                    this.projectsData = response.data;
                }
            });
    }

    getCity(str): string {
        const cityData = str ? str.split(',') : [];
        let city = '';
        if (cityData.length > 0) {
            city = cityData[0].trim() + ', ' + cityData[cityData.length - 1].trim();
            city = city === ', ' ? '' : city;
        }
        return city;
    }

    toggleBasicDataEdit(isCancel): void {
        this.basicDataNoEdit = !this.basicDataNoEdit;
        if (isCancel) {
            this.profileData = this.rawProfile;
            this.basicProfileForm = this.createBasicProfileForm();
        }
    }

    toggleAdditionalDataEdit(isCancel): void {
        this.additionalDataNoEdit = !this.additionalDataNoEdit;
        if (isCancel) {
            this.formatDemogValues(this.rawDemogs);
        }
    }

    togglePasswordDataEdit(isCancel): void {
        this.passwordDataNoEdit = !this.passwordDataNoEdit;
        if (isCancel) {
            this.memberPasswordForm = this.createPasswordForm();
            this.memberFirstPasswordForm = this.createFirstPasswordForm();
        }
    }

    savePassword(password): void {

        console.log(password.getRawValue());

        if (!password.getRawValue().hasOwnProperty('oldPassword')) {
            console.log('Create password');

            this._profileService.createMyPassword(password.getRawValue())
                .then(x => {

                    // Show the success message
                    this._matSnackBar.open(this._translate.instant('Your password is created successfully.'), '', {
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        duration: 2000
                    });
                })
                .catch(err => Promise.reject(err))
                .then(() => {
                    this.togglePasswordDataEdit(true);
                    this.getMemberProfile();
                }, err => {
                    console.log(err);
                });

        } else {
            console.log('Edit password');

            this._profileService.editMyPassword(password.getRawValue())
                .then(x => {

                    // Show the success message
                    this._matSnackBar.open(this._translate.instant('Your password is changed successfully.'), '', {
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        duration: 2000
                    });
                })
                .catch(err => Promise.reject(err))
                .then(() => {
                    this.togglePasswordDataEdit(true);
                }, err => {
                    const validationErrors = err.error;
                    const formControl = this.memberPasswordForm.get('oldPassword');
                    if (formControl) {
                        // activate the error message
                        formControl.setErrors({
                            serverError: validationErrors.error
                        });
                        console.log(validationErrors.error);
                    }
                });
        }

    }


    saveBasicProfile(member): void {

        const data = member.getRawValue();

        if (moment.isMoment(data.date_of_birth)) {
            data.date_of_birth = data.date_of_birth.format('YYYY-MM-DD');
        }

        // do not send null fields
        for (const [key, value] of Object.entries(data)) {
            if (value === null) {
                delete data[key];
            }
        }
        data.residence_city_id = this.residenceSiteIdSelected ? this.residenceSiteIdSelected : data.residence_city_id || 0;
        data.declared_city_id = this.declaredSiteIdSelected ? this.declaredSiteIdSelected : data.declared_city_id || 0;

        this._profileService.updateProfile(data)
            .then(x => {
                // Show the success message
                this._matSnackBar.open(this._translate.instant('Profile data successfully updated.'), '', {
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 2000
                });

                this.basicDataNoEdit = true;
            })
            .catch(err => Promise.reject(err))
            .then(x => { }, err => {
                const validationErrors = err.error;
                for (const key of Object.keys(validationErrors)) {
                    const formControl = this.basicProfileForm.get(key);
                    if (formControl) {
                        console.log(validationErrors);
                        formControl.setErrors({
                            serverError: validationErrors[key][0]
                        });
                    }
                }
            });
    }

    checkServerError(form, fieldName): any {
        return form.get(fieldName).errors ? form.get(fieldName).errors.serverError ?
            form.get(fieldName).errors.serverError : 'This field is required!' : false;
    }

    saveAdditionalProfile(addData): void {

        const data = addData.getRawValue();
        const uniqueIds = [];
        const colectChekboxes = {};

        for (const key in data) {
            if (data.hasOwnProperty(key)) {

                let isCheckbox = false;
                let CheckboxOptionId = 0;

                let type = key.replace('ms', '');
                type = type.replace(/\d+/g, ''); // remove numbers

                let id = key.substr(0, key.indexOf('ms'));

                if (id === '') {
                    id = (key.match(/\d+/g).map(Number)).toString();
                } else {
                    isCheckbox = true;
                    id = (id.match(/\d+/g).map(Number)).toString();
                    CheckboxOptionId = parseInt(id, 10);
                }

                if (uniqueIds.indexOf(id) < 0) {
                    uniqueIds.push(id);

                    if (isCheckbox) {
                        colectChekboxes[id] = [];
                    }
                }

                if (type !== 'enum') {
                    if (data[key]) {
                        if (key.indexOf('date') > -1 && moment.isMoment(data[key])) {
                            this._profileService.updateProfileDemog(parseInt(id, 10), data[key].format('YYYY-MM-DD'));
                        } else {
                            this._profileService.updateProfileDemog(parseInt(id, 10), data[key]);
                        }
                    }
                } else {

                    if (!isCheckbox) {
                        if (data[key]) {
                            this._profileService.updateProfileDemog(parseInt(id, 10), [data[key]]);
                        }
                    } else {
                        if (data[key] && data[key].length > 0) {
                            this._profileService.updateProfileDemog(parseInt(id, 10), data[key]);
                        }
                    }
                }
            }
        }

        // Show the success message
        this._matSnackBar.open(this._translate.instant('Profile data successfully updated.'), '', {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 2000
        });

        this.additionalDataNoEdit = true;

    }

    detachSocial(source): void {
        console.log(source);
        this._profileService.detachFromSocial()
            .then(x => {
                // Show the success message
                this._matSnackBar.open(this._translate.instant('Profile detached from social network.'), '', {
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 2000
                });

                this.basicDataNoEdit = true;
            })
            .catch(err => Promise.reject(err))
            .then(x => { }, err => {
                console.log(err);
            });
    }

    attachSocial(source): void {
        console.log(source);

        this._authService.authenticateSocial(source, false);
        console.log('authenticateSocial called.');

        this._authService.socialLoginResponse
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(result => {
                console.log('authenticateSocial result:');
                console.log(result);
                this._profileService.attachToSocial(result.authToken, source)
                    .then(response => {
                        console.log('Success!');
                    }, err => {
                        console.log('Error!', err.error);
                        if (err.error.token && err.error.token.length) {

                            // Show the error message
                            this._matSnackBar.open(this._translate.instant(err.error.token[0]), '', {
                                verticalPosition: 'top',
                                horizontalPosition: 'right',
                                duration: 3000
                            });
                        }
                    });
            });
    }

    getIdByOption(object, value): any {
        let retVal = 0;
        object.forEach(element => {
            if (element.option === value) {
                retVal = element.id;
            }
        });
        return retVal;
    }

    formatDemogValues(data): void {

        this.profileDemogs = [];
        this.additionalProfileForm = this.createAdditionalProfileForm();

        data.forEach(element => {

            if (element.type === 'enum') {

                this._profileService.getEnumOptions(element.id)
                    .then(response => {

                        if (response.data) {
                            element.source = response.data;
                        }

                        if (element.multi_select) {
                            const defaultMultiselectValue = [];
                            element.source.forEach(item => {
                                defaultMultiselectValue.push(this.getIdByOption(element.value, item.option));
                            });
                            this.additionalProfileForm.addControl(element.type + element.id + 'ms', new FormControl(defaultMultiselectValue));
                        } else {
                            this.additionalProfileForm.addControl(element.type + element.id, new FormControl(element.value[0] ? element.value[0].id : null));
                        }

                        this.checkCustomDemogs(element.name);

                    });

            } else {
                this.additionalProfileForm.addControl(element.type + element.id, new FormControl(element.value));
            }

            this.profileDemogs.push(element);
        });


    }

    deleteAsset(id, collection): void {

        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = this._translate.instant('Are you sure you want to delete the file?');

        if (collection !== 'cv') {
            this.confirmDialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this._profileService.deleteMemberAsset(id, collection)
                        .then(x => {
                            // Show the success message
                            this._matSnackBar.open(this._translate.instant('File deleted successfully.'), '', {
                                verticalPosition: 'top',
                                horizontalPosition: 'right',
                                duration: 2000
                            });
                        })
                        .catch(err => Promise.reject(err))
                        .then(x => { }, err => {
                            console.log('Error:', err);
                            // Show the error message
                            this._matSnackBar.open(this._translate.instant('The file cannot be deleted.'), '', {
                                verticalPosition: 'top',
                                horizontalPosition: 'right',
                                duration: 2000
                            });
                        });
                }
                this.confirmDialogRef = null;
            });

        } else {

            this.confirmDialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this._profileService.deleteMemberCv(id, collection)
                        .then(x => {
                            // Show the success message
                            this._matSnackBar.open(this._translate.instant('CV successfully deleted.'), '', {
                                verticalPosition: 'top',
                                horizontalPosition: 'right',
                                duration: 2000
                            });
                        })
                        .catch(err => Promise.reject(err))
                        .then(x => { }, err => {
                            console.log('Error:', err);
                            // Show the error message
                            this._matSnackBar.open(this._translate.instant('CV cannot be deleted.'), '', {
                                verticalPosition: 'top',
                                horizontalPosition: 'right',
                                duration: 2000
                            });
                        });
                }
                this.confirmDialogRef = null;
            });

        }
    }

    downloadAsset(id, collection, fileName): void {
        this._profileService.downloadMemberAsset(id, collection, fileName);
    }

    downloadCv(fileName): void {
        this._profileService.downloadMemberCv(fileName);
    }

    updateDataIcons(data): void {
        let icon = '';
        data.forEach(element => {
            switch (element.type) {
                case 'image/jpeg':
                    icon = 'photo';
                    break;

                case 'image/png':
                    icon = 'photo';
                    break;

                case 'application/pdf':
                    icon = 'insert_drive_file';
                    break;

                case 'application/msword':
                    icon = 'insert_drive_file';
                    break;

                default:
                    icon = 'insert_drive_file';
                    break;
            }
            element.icon = icon;
        });
    }

    deleteProfile(): void {
        console.log('Delete profile');

        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = this._translate.instant('Are you sure you want to delete your profile?');

        this.confirmDialogRef.afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(result => {
                if (result) {
                    this._profileService.depersonalizer()
                        .then(x => {
                            // Show the success message
                            this._matSnackBar.open(this._translate.instant('Your profile has been deleted successfully.'), '', {
                                verticalPosition: 'top',
                                horizontalPosition: 'right',
                                duration: 2000
                            });

                            this._authService.logout();
                            this._router.navigate(['/home']);
                        })
                        .catch(err => Promise.reject(err))
                        .then(x => { }, err => {
                            console.log('Error:', err);
                            // Show the error message
                            this._matSnackBar.open(this._translate.instant('Your profile cannot be deleted.'), '', {
                                verticalPosition: 'top',
                                horizontalPosition: 'right',
                                duration: 2000
                            });
                        });
                }
                this.confirmDialogRef = null;
            });
    }

    removeMemberSkill(chip, group): void {
        this._profileService.removeSkillFromMember(chip.id, group);
    }

    // assignSkillToMember(group): void {

    //     this.dialogRef = this._matDialog.open(MemberSkillFormDialogComponent, {
    //         panelClass: 'skill-form-dialog',
    //         data: {
    //             group: group,
    //             memberSkills: this.memberSkills[group],
    //             action: 'new'
    //         }
    //     });

    //     this.dialogRef.afterClosed()
    //         .subscribe(response => {
    //             if (!response) {
    //                 return;
    //             }
    //             const actionType: string = response[0];
    //             const formData: FormGroup = response[1];
    //             switch (actionType) {
    //                 /**
    //                  * Save
    //                  */
    //                 case 'save':

    //                     // this._memberManagementService.updateMember(formData.getRawValue());

    //                     break;
    //                 /**
    //                  * Delete
    //                  */
    //                 case 'delete':

    //                     // this.deleteMember(member);

    //                     break;
    //             }
    //         });

    // }

    declaredSiteOnChange(site): void {
        this.declaredSiteIdSelected = site.osm_id;
        this.basicProfileForm.controls['declaredCityName'].setValue(site.display_name);
        this.basicProfileForm.markAsDirty();
    }

    resitenceSiteOnChange(site): void {
        this.residenceSiteIdSelected = site.osm_id;
        this.basicProfileForm.controls['residenceCityName'].setValue(site.display_name);
        this.basicProfileForm.markAsDirty();
    }

    getValidGenders(): void {
        this._profileService.getValidGendersOfMemberChildren()
            .then(response => {
                console.log(response.data);
                if (response.data) {
                    this.genderData = response.data;
                } else {
                    this.genderData.length = 0;
                }
            });
    }

    getValidLanguages(): void {
        this._profileService.getValidLangsOfSpokenLanguage()
            .then(response => {
                console.log(response.data);
                if (response.data) {
                    this.languageData = response.data;
                } else {
                    this.languageData.length = 0;
                }
            });
    }

    getValidLevels(): void {
        this._profileService.getValidLevelsOfSpokenLanguage()
            .then(response => {
                console.log(response.data);
                if (response.data) {
                    this.levelData = [];
                    Object.keys(response.data).forEach(item => {
                        this.levelData.push({ value: item, name: response.data[item] });
                    });
                    console.log(this.levelData);
                    this.levelDataObj = response.data;
                } else {
                    this.levelData.length = 0;
                    this.levelDataObj = {};
                }
            });
    }

    checkCustomDemogs(name): void {
        if (name === 'Member Children') {
            this.getChildrenData();
        }

        if (name === 'Member Spoken Language') {
            this.getSpokenData();
        }

        if (name === 'Member Work Experience') {
            this.getExperienceData();
        }

        if (name === 'Member Education') {
            this.getEducationData();
        }
    }

    getChildrenData(): void {
        this._profileService.listMemberChildren();
    }

    getSpokenData(): void {
        this._profileService.listMemberSpokenLanguages();
    }

    getExperienceData(): void {
        this._profileService.listMemberWorkExperience();
    }

    getEducationData(): void {
        this._profileService.listMemberEducation();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {

        if (!this._authService.isAuthenticated()) {
            this.loggedIn = false;
            this._router.navigate(['/login']);
        } else {
            this.loggedIn = true;
            this.getMemberProfile();
            this.getMemberProjects();
            console.log(this._authService.userInfo);
            if (this._authService.userInfo) {
                this.gdprFlag = parseInt(this._authService.userInfo['gdpr_flag'], 10);
            }
        }

        this.setupUploaderOptions();

        // recheck for gdpr flag
        this._authService.userSetComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                if (this._authService.userInfo) {
                    this.gdprFlag = parseInt(this._authService.userInfo['gdpr_flag'], 10);
                }
            });

        this._authService.logoutComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                this.loggedIn = false;
                // this._router.navigate(['/home']);
            });

        this._profileService.onMemberImageChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                this.createImageFromBlob(response);
            }, err => {

            });

        this._profileService.onProfileChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                if (response.data) {
                    this.profileData = response.data;
                    this.rawProfile = this.profileData;
                    this.basicProfileForm = this.createBasicProfileForm();
                }
            }, err => {

            });

        this._profileService.onMemberFilesChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                console.log(response);
                this.docFiles = response.data;
                this.updateDataIcons(this.docFiles);
                // this.updateDataDateFormat(this.docFiles);
            }, err => {

            });

        this._profileService.getAllCitiesList()
            .then(response => {
                if (response) {
                    this.cities = _.orderBy(response, 'city', 'asc');
                    console.log(this.cities);
                }
            });

        this._profileService.onMemberCvChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                console.log(response);
                this.cvFile = response;
                this.cvFile.name = this.cvFile.name ? this.cvFile.name.split('.').slice(0, -1).join('.') : '';
                this.updateDataIcons([this.cvFile]);
                // this.updateDataDateFormat([this.cvFile]);
            }, err => {

            });


        // Notifications related

        this._notificationsService.listAllNotifications();
        this._notificationsService.onNotificationsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((newNotificationCount) => {
                this.unreadedNotifications = '';
                if (newNotificationCount > 0) {
                    this.unreadedNotifications = newNotificationCount.toString();

                    // Update project statuses
                    this.getMemberProjects();
                }
            });

        if (this._notificationsService.fromNotifications) {
            this.activeTabIndex = 4;
            this._notificationsService.fromNotifications = false;
        }

        // Demogs related

        this._profileService.onProfileDemogsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                this.profileDemogs = [];
                if (response.data) {
                    this.rawDemogs = response.data;
                    this.formatDemogValues(response.data);
                    console.log(this.profileDemogs)
                }
            });

        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();

            });
        this.getTranslations();

        this._translationLoader.pageTranslationsLoaded
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.addDefaultValueToFilters();
                setTimeout(() => {
                    this.setupUploaderOptions();
                }, 900);
            });

        // Skills related

        this._profileService.getSkillGroups()
            .then(response => {
                this.skillGroups = response;

                this.skillGroups.forEach(group => {
                    this._profileService.getSkills(group)
                        .then(skills => {
                            this.allSkills[group] = skills;
                        });

                    this._profileService.getSkills(group)
                        .then(memberSkills => {
                            this.memberSkills[group] = memberSkills;
                        });
                });
            });

        this._profileService.onMemberSkillsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                if (response.group) {
                    this.memberSkills[response.group] = response.data;
                }
            });

        this._uploadService.onFileUploaded
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {

                this._profileService.getMemberProfileImage();

            }, err => {

            });


        this._profileService.onMemberChildrenChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                console.log(response);
                if (response.data) {
                    this.customDemogDataChild = response.data;
                } else {
                    this.customDemogDataChild.length = 0;
                }
            });

        this._profileService.onMemberLanguageChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                if (response.data) {
                    this.customDemogDataLang = response.data;
                } else {
                    this.customDemogDataLang.length = 0;
                }
            });

        this._profileService.onMemberWorkExperienceChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                if (response.data) {
                    console.log(response.data);
                    this.customDemogDataExperience = response.data;
                } else {
                    this.customDemogDataExperience.length = 0;
                }
            });
        
        this._profileService.onMemberEducationChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(response => {
                if (response.data) {
                    console.log(response.data);
                    this.customDemogDataEducation = response.data;
                } else {
                    this.customDemogDataEducation.length = 0;
                }
            });


        this.getValidGenders();
        this.getValidLanguages();
        this.getValidLevels();

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
        const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

        return (invalidCtrl || invalidParent);
    }
}

export class PasswordValidation {

    static MatchPassword(AC: AbstractControl): any {
        const password = AC.parent ? AC.parent.get('password').value : '';
        const passwordConfirm = AC.value;
        if (password !== '' && password !== passwordConfirm) {
            AC.setErrors({ MatchPassword: true });
            return { passwordsNotMatching: true };
        } else {
            return null;
        }
    }
    static WeakPassword(AC: AbstractControl): any {
        const password = AC.value; // to get value in input tag
        if (password.length && (password.length < 8 || !password.match(/\d/)
            || password.toLowerCase() === password || password.toUpperCase() === password)) {
            AC.setErrors({ WeakPassword: true });
            return { passwordWeak: true };

        } else {
            return null;
        }
    }
}
